import React from "react";
import { Chip } from "@mui/material";
import type { MakeupStatus } from "./types";

export const STATUS_CHIPS: Record<MakeupStatus, { color: any; label: string }> = {
  ready:                 { color: "success", label: "Ready" },
  imported:              { color: "success", label: "Imported" },
  already_imported:      { color: "info",    label: "Already imported" },
  unmapped_student:      { color: "error",   label: "Unmapped student" },
  unmapped_staff:        { color: "error",   label: "Unmapped staff" },
  missing_makeup_id:     { color: "error",   label: "Missing makeup ID" },
  missing_makeup_day:    { color: "error",   label: "Missing makeup day" },
  missing_grade_subject: { color: "warning", label: "Missing grade/subject" },
  missing_location:      { color: "warning", label: "Missing location" },
  invalid_date:          { color: "error",   label: "Invalid date" },
  invalid_time:          { color: "error",   label: "Invalid time" },
  cancelled:             { color: "default", label: "Cancelled" },
  released:              { color: "default", label: "Released" },
  conflict:              { color: "warning", label: "Conflict" },
  failed:                { color: "error",   label: "Failed" },
};

export function statusChip(s: MakeupStatus) {
  const c = STATUS_CHIPS[s] ?? { color: "default", label: s };
  return <Chip size="small" color={c.color} label={c.label} />;
}

export function formatDate(s?: string | null): string {
  if (!s) return "—";
  try {
    const d = new Date(s);
    if (Number.isNaN(d.getTime())) return String(s);
    return d.toLocaleDateString(undefined, {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  } catch {
    return String(s);
  }
}

export function formatTime(s?: string | null): string {
  if (!s) return "—";
  const parts = String(s).split(":");
  if (parts.length < 2) return String(s);
  const h = parseInt(parts[0], 10);
  const m = parts[1];
  if (Number.isNaN(h)) return String(s);
  const suffix = h >= 12 ? "PM" : "AM";
  const h12 = ((h + 11) % 12) + 1;
  return `${h12}:${m} ${suffix}`;
}
